<template>

<div class="card card-dark card-icon h-100">
    <span class="main-icon icon icon-feather"></span>

    <div class="card-body">     
        <h3 class="text-uppercase mb-3">
            Testimonials
        </h3>
        <div id="testimonials-carousel" class="owl-carousel">
            <div>
                <div class="font-italic mb-2">
                   “I just bought a subscription for OFMDB and it is the best thing that ever happened to me! Instead of having to subscribe separately for all models that I love and paying 200$ a month, I paid 19.99$ and i got full access to all content of the girls i love! What is more, I even learned about new amazing models that I never knew existed! Best 20 bucks I spend in my life!.”
                </div>
                <span class="autor">John</span>
            </div>
            <div>
                <div class="font-italic mb-2">
                    "Oh my god, the moment that I saw OFMDB it was like my dream came true! The design of the website, the models inside, it was like heaven! I explored the website and I saw the free photos and I immediately knew that I would like to unlock all content! It worked like a miracle! This is the perfect place for me to spend hours and enjoy the beauty fo the sexiest girls from onlyfans."
                </div>
                <span class="autor">Tom</span>
            </div>

            <div>
                <div class="font-italic mb-2">
                    "Before finding OFMDB I used to spend hundreds of dollars on buying private content when chatting with some of the most famous onlyfans models. One day I realized that most of the onlyfans models have assistants that answer all their messages for them. This broke my trust in the system. Their job was only to sell me more and more photos! I felt like an idiot. I bought a subscription at OFMDB and received all this content that I bought for thousands of dollars just for 20$ a month. This is INSANE! I don't know who came up with the idea but for me, they are like the Robin Hoods of the adult industry! Thank you!!!!"
                </div>
                <span class="autor">Mike</span>
            </div>

            <div>
                <div class="font-italic mb-2">
                    "This is Brilliant!!! I always dreamed of searching for onlyfans models on the web! OFMDB gave me the opportunity to easily find some of the most amazing models out there! What is the best part of that is that for just 20 bucks a month you get access to all their photos and videos! This is a gold mine for me! "
                </div>
                <span class="autor">Nathan</span>
            </div>
        </div>
    </div>
</div>


</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

        }

    }
</script>
